import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { IFormKey, IFormSelectOption } from 'src/app/modules/shared/models/forms';
import { LoggerService } from 'src/app/services/logger.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { document_change_form_keys, document_change_previdence_form_group_config, document_change_previdence_table_keys } from './document-change.constants';
import { IDocumentUpdate } from '../beneficiary-change-isv/beneficiary-change-isv.constants';
import { FormUtils } from 'src/app/utils/FormUtils';

@Component({
  selector: 'app-document-change',
  templateUrl: './document-change.component.html'
})
export class DocumentChangeComponent implements OnInit, OnDestroy {

  @Input() form: FormGroup;
  @Input() documentTypeList: any[];
  @Input() previousDocuments: IDocumentUpdate[];
  @Input() documentReleaseAuthorityList: any[];
  @Input() isReadOnly: boolean;
  @Input() isPolicyPrevidenziale: boolean;
  @Input({ required: false }) tableValues?: any[];

  keys: IFormKey[];
  tableKeys: IFormKey[];
  destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.keys = CommonUtils.assign(
      this.isPolicyPrevidenziale
        ? document_change_previdence_form_group_config
        : document_change_form_keys
    );
    this.tableKeys = CommonUtils.assign(document_change_previdence_table_keys)
    this.populateFormKeys();
    if(this.isPolicyPrevidenziale){
      this.patchWithPreviousDocument();
    }
  }

  patchWithPreviousDocument(): void {
    const previousDocument = this.previousDocuments.reduce((latest, current) => {
      return new Date(current.timestamp) > new Date(latest.timestamp) ? current : latest;
    });
    FormUtils.patchFormFromObject({
      tipoDocumento: previousDocument.codiceDocumentoRiconoscimento,
      documentNumber: previousDocument.numeroDocumento,
      documentReleaseDate: previousDocument.dataRilascio,
      enteRilascio: previousDocument.codiceEnteRilascio,
      documentReleasePlace: previousDocument.luogoRilascio,
      documentExpirationDate: previousDocument.dataFineValidita
    }, this.form);
  }

  populateFormKeys(): void {
    if (this.form) {
      let documentReleaseAuthorityKey;
      const documentTypeKey = this.keys.find(
        (key) => key.controlName === 'tipoDocumento'
      );
      if (documentTypeKey) {
        this.setOptions(this.keys, 'tipoDocumento', this.documentTypeList);
      }

      documentReleaseAuthorityKey = this.keys.find(
        (key) => key.controlName === 'enteRilascio'
      );
      if (documentReleaseAuthorityKey) {
        this.setOptions(this.keys, 'enteRilascio', this.documentReleaseAuthorityList);
      }
    }
  }

  setOptions(keys: IFormKey[], controlName: string, options: IFormSelectOption[]) {
    if (!keys) {
      return;
    }
    const key = keys.find(k => k.controlName === controlName);
    if (key) {
      key.options = options;
    }
  }

  reset(): void {
    LoggerService.logInfo(this.constructor.name, 'reset');
    this.form?.reset();
    if (this.isFormValorizedAndUni20) this.form.get('enteRilascio').disable();
  }

  get isFormValorizedAndUni20(): boolean {
    return this.form && !this.isPolicyPrevidenziale
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
